<template> </template>

<script>
import { LOGOUT, SESSION_RESET_STATE, ECOSYSTEM_RESET_STATE } from "@/store/actions.type";

export default {
  name: "logout",
  created() {
    this.$store.dispatch(SESSION_RESET_STATE);
    this.$store.dispatch(ECOSYSTEM_RESET_STATE);
    this.$store.dispatch(LOGOUT).then(() => {
      this.$router.push({ name: "login" });
    });
  }
};
</script>
